import { render, staticRenderFns } from "./EventDetailsDialog.vue?vue&type=template&id=488a241d"
import script from "./EventDetailsDialog.vue?vue&type=script&lang=js"
export * from "./EventDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports